/**
 * Survival: what happens after something has already gone wrong.
 */

import type { PerkBranch } from '@/sim/progression/perkBranchContract';

export const SURVIVAL_BRANCH = {
  id: 'survival',
  title: 'Survival',
  blurb: 'Household preparedness for the unlikely event of a nearby detonation.',
} as const satisfies PerkBranch;
